import { ClipboardList } from "lucide-react";
import { SettledRules } from "@/components/ui/SettledRules";

/**
 * Năm quy tắc của Đơn bán hàng — anh Toàn chốt 19/09/2026 theo chuẩn ERP (SO-R01..R03, SO-WAVE-R01), khách bác lại được. Trước đây là
 * các thẻ vàng "chờ khách xác nhận" rải trên trang; nay là một mục gập trung tính để người dùng tra khi cần.
 */
export const SALES_ORDER_RULES = ["source", "split", "date", "review", "amendment"] as const;

export function SalesOrderRules() {
  return <SettledRules ns="so" rules={SALES_ORDER_RULES} icon={ClipboardList} />;
}
